export default __webpack_public_path__ + "static/media/avia.2b0ee252.png";